import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  tags: {
    description: 'orderDrawer.tags.tags',
    defaultMessage: 'Tags',
    id: '4Ch9OW',
  },
  tagsSummaryText: {
    description: 'orderDrawer.tags.summarytext',
    defaultMessage: 'View All {tagCount} Tags',
    id: 'eBeixL',
  },
  noTags: {
    defaultMessage: 'There are no tags.',
    description: 'ordersDrawer.noTags',
    id: 'XX3SEz',
  },
});
